import React from "react";
import { Link } from "react-router-dom";
import { ajax } from "../components/globals";
import { UIInput, UIButton, UIConfirmPopup } from "../components/guiElements";
import { Languages } from "../components/languages";

export default class ForgotPassword extends React.Component {

    le = Languages.getSection("PasswordRecovery");

    state = {
        username: "",
        loading: false,
        successPopupOpen: false,
        error: ""
    };

    goToLogin = () => {
        this.props.history.replace("/");
    };

    keyUp = event => {
        if (event.key === "Enter" && !this.state.loading)
        {
            this.submit();
        }
    };

    submit = () => {
        if (this.state.loading) {
            return;
        }

        if (!this.state.username.trim()) {
            this.setState({
                error: this.le.request.requiredError
            });
            return;
        }

        this.setState({
            loading: true,
            successPopupOpen: false,
            error: ""
        });

        ajax(
            this,
            {
                method: "post",
                url: "/api/user/password-reset/request",
                data: {username: this.state.username.trim()}
            },
            () => {
                this.setState({
                    username: "",
                    loading: false,
                    successPopupOpen: true,
                    error: ""
                });
            },
            () => {
                this.setState({
                    loading: false,
                    successPopupOpen: false,
                    error: this.le.request.requestError
                });
            }
        );
    };

    render() {
        return (
            <div className="full-panel page-password-recovery">
                <div className="page-login">
                    <div className={"widget " + (this.state.loading ? "disabled" : "")}>
                        <div className="widget-header">
                            <div className="login-header-logo" />
                        </div>

                        <div className="widget-content">
                            <div className="widget-content-title">
                                {this.le.request.title}
                            </div>

                            <UIInput
                                maxLength={100}
                                name="username"
                                value={this.state.username}
                                hint={this.le.request.usernamePlaceholder}
                                onKeyUp={this.keyUp}
                                onChange={event =>
                                    this.setState({
                                        username: event.target.value
                                    })
                                }
                            />

                            <div className="widget-content-subtitle login-notes">
                                {this.le.request.instructions}
                            </div>

                            <UIButton
                                className="confirm slim"
                                text={this.le.request.submit}
                                disabled={this.state.loading}
                                onClick={this.submit}
                            />

                            {this.state.error &&
                                <div className="login-error" role="alert">
                                    {this.state.error}
                                </div>
                            }

                            <Link
                                className="forgot-password-link"
                                to="/"
                            >
                                {this.le.common.backToLogin}
                            </Link>
                        </div>
                    </div>
                </div>
                {this.state.successPopupOpen &&
                    <UIConfirmPopup
                        title={this.le.request.successTitle}
                        message={this.le.request.genericResult}
                        confirmText={this.le.common.backToLogin}
                        icon="fa-solid fa-envelope-circle-check"
                        showCancelButton={false}
                        closeOnEscape={false}
                        closeOnOverlay={false}
                        autoFocusConfirm={true}
                        loading={false}
                        onConfirm={this.goToLogin}
                    />
                }
            </div>
        );
    }
}